import { call, put, select } from 'redux-saga/effects';
import cirrusClient from '../../../services/api/cirrus-client';
import { fetchMessageAction } from '../fetchMessage/action';
import { fetchMessageSessionAction } from '../fetchMessageSession/action';
import { selectUserCredentials } from '../../../state/userCredential/userCredentialSlice';

export function* sendMessageSaga(action) {
    const {
        messagesessionId,
        type,
        message,
        destination,
        fromNumber,
        mediaData,
        mimeType,
        fileSize
    } = action.payload;
    try {
        const { domain, user } = yield select(selectUserCredentials);
        let messageType = type;
        if (mediaData) {
            messageType = type === 'sms' ? 'mms' : 'chat-media';
        }

        const params = {
            type: messageType,
            message,
            destination,
        };

        if (type === 'sms') { 
            params.from_num = fromNumber;
        }

        if (mediaData) {
            params.data = mediaData;
            params['mime-type'] = mimeType;
            params.size = fileSize;
        }

        const response = yield call(cirrusClient.post, `/v2/domains/${domain}/users/${user}/messagesessions/${messagesessionId}/messages`, params)

        console.log('Send message response:', response)
        if (response.data.code === 202) {
            yield put(fetchMessageAction(messagesessionId));
            yield put(fetchMessageSessionAction());
        } else {
            throw new Error('Message not accepted by the server');
        }
    } catch (error) {
        console.error('Error sending message:', error);
    }
}